import { createSelector } from '@ngrx/store';
import { getVirtualDebitCardState } from './appState';
import { operationTypes } from '../services/virtual-debit-card.service';


export interface VirtualDebitCardState {
  readonly cards: {
    readonly data: Array<any>;
    readonly error: boolean;
  };
  readonly newCard: {
    readonly amount: number;
    readonly address: string;
    readonly operationType?: operationTypes;
    readonly epin?: number;
  };
  readonly auth: boolean;
}

export const getVirtualDebitCardInfo = createSelector(
  getVirtualDebitCardState,
  (state: VirtualDebitCardState) => state.newCard
);

export const getVirtualCards = createSelector(
  getVirtualDebitCardState,
  (state: VirtualDebitCardState) => state.cards
);

export const getVirtualDebitCardDetailAuth = createSelector(
  getVirtualDebitCardState,
  (state: VirtualDebitCardState) => state.auth
);
